var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_411_2)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M80 160C124.183 160 160 124.183 160 80C160 35.8172 124.183 0 80 0C35.8172 0 0 35.8172 0 80C0 124.183 35.8172 160 80 160Z",
  fill: "#F6F0DA"
}), /*#__PURE__*/React.createElement("path", {
  d: "M111.4 88.5007C117.3 86.5007 123 81.2007 123.2 78.9007C123.5 75.0007 118.9 73.5007 110.2 76.1007C109.346 76.3527 108.543 76.6667 107.786 77.0217V89.4497C108.834 89.2787 110.027 88.9657 111.4 88.5007Z",
  fill: "#F9BC84"
}), /*#__PURE__*/React.createElement("path", {
  d: "M115.4 74.1003C121.3 72.1003 125 68.8003 125.2 66.5003C125.5 62.6003 120.9 61.1003 112.2 63.7003C110.536 64.1913 109.051 64.9033 107.786 65.7443V76.0453C109.842 75.9113 112.473 75.0923 115.4 74.1003Z",
  fill: "#F9BC84"
}), /*#__PURE__*/React.createElement("path", {
  d: "M115.4 97.9007C118 95.8007 120.9 93.7007 118.7 90.4007C116.7 87.3007 112.9 88.0006 110.4 89.2006L107.786 90.8137V104.472L115.4 97.9007Z",
  fill: "#F9BC84"
}), /*#__PURE__*/React.createElement("path", {
  d: "M114.9 60.3C118.5 59.4 126 55.3 126 52C126 48.8 117.9 47.7 113.9 49.1L107.786 50.711V62.158L114.9 60.3Z",
  fill: "#F9BC84"
}), /*#__PURE__*/React.createElement("path", {
  d: "M107.786 50.7112V32.2812C107.786 31.0682 106.794 30.0752 105.58 30.0752H61.668C60.455 30.0752 59.462 31.0672 59.462 32.2812V127.522C59.462 128.735 60.455 129.728 61.668 129.728H105.581C106.794 129.728 107.787 128.735 107.787 127.522V104.47V90.8132V89.4482V77.0212V76.0462V65.7442V62.1572V50.7112H107.786Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M104.7 26.5996H62.6C58.9 26.5996 55.8 29.5996 55.8 33.3996V65.9996V126C55.8 127.5 56.3 128.9 57.1 130C58.3 131.7 60.3 132.8 62.5 132.8H104.6C108.3 132.8 111.4 129.8 111.4 126L111.5 77.4996V73.4996V67.2996V60.2996V33.3996C111.5 29.6996 108.5 26.5996 104.7 26.5996ZM107.4 125.9C107.3 127.3 106.1 128.5 104.8 128.5H62.6C61.2 128.5 60 127.4 60 125.9V33.2996C60 31.8996 61.1 30.6996 62.6 30.6996H70.4V30.7996V32.3996C70.4 33.7996 71.5 34.8996 72.9 34.8996H92.9C94.3 34.8996 95.4 33.7996 95.4 32.3996V30.7996V30.6996H104.8C106.2 30.6996 107.4 31.7996 107.4 33.2996V125.9Z",
  fill: "#260046"
}), /*#__PURE__*/React.createElement("path", {
  d: "M91.1 117.7H76.2C75.2 117.7 74.5 118.5 74.5 119.4C74.5 120.3 75.3 121.1 76.2 121.1H91.1C92.1 121.1 92.8 120.3 92.8 119.4C92.9 118.5 92.1 117.7 91.1 117.7Z",
  fill: "#EA4403"
}), /*#__PURE__*/React.createElement("path", {
  d: "M51.7 134.9C51.1 135.3 50.5 135.7 49.9 136C50.5 135.7 51.1 135.3 51.7 134.9Z",
  fill: "#F9BC84"
}), /*#__PURE__*/React.createElement("path", {
  d: "M51 135.3C50.6 135.5 50.3 135.7 49.9 136C50.5 135.7 51.1 135.3 51.7 134.9C51.5 135 51.3 135.2 51 135.3Z",
  fill: "#F9BC84"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M51 135.3C50.6 135.5 50.3 135.7 49.9 136C50.5 135.7 51.1 135.3 51.7 134.9C51.5 135 51.3 135.2 51 135.3Z",
  fill: "#F9BC84"
}), /*#__PURE__*/React.createElement("path", {
  d: "M65.9 91.7002C64.9 91.7002 64.2 92.5002 64.2 93.4002C64.2 94.4002 65 95.1002 65.9 95.1002H101.9C102.9 95.1002 103.6 94.3002 103.6 93.4002C103.6 92.4002 102.8 91.7002 101.9 91.7002H65.9Z",
  fill: "#EAEAEA"
}), /*#__PURE__*/React.createElement("path", {
  d: "M79.9 72.3702L79.1 71.8702L64.898 62.9202V78.2002C64.898 79.0982 65.733 79.8022 66.8 79.8022H93C94.066 79.8022 94.902 79.0982 94.902 78.2002V62.8232L80.7 71.8702L79.9 72.3702Z",
  fill: "#260046"
}), /*#__PURE__*/React.createElement("path", {
  d: "M94.859 61.85C94.673 61.088 93.898 60.498 93 60.498H66.8C65.802 60.498 65.016 61.117 64.918 61.933L79.9 71.37L94.859 61.85Z",
  fill: "#260046"
}), /*#__PURE__*/React.createElement("path", {
  d: "M93 59.7021H66.8C65.287 59.7021 64.102 60.7551 64.102 62.1001V78.2001C64.102 79.5451 65.287 80.5981 66.8 80.5981H93C94.513 80.5981 95.697 79.5451 95.697 78.2001V62.2001C95.697 60.8231 94.487 59.7021 93 59.7021ZM95.3 62.2001V62.5701L94.902 62.8232V78.2001C94.902 79.0981 94.066 79.8022 93 79.8022H66.8C65.734 79.8022 64.898 79.0981 64.898 78.2001V62.9201L64.5 62.6701V62.1001V61.6701L64.917 61.9331C65.015 61.1171 65.801 60.4981 66.799 60.4981H93C93.898 60.4981 94.673 61.0891 94.859 61.8501L95.3 61.5701V62.2001Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M79.9 71.3703L64.917 61.9333L64.5 61.6703V62.1003V62.6703L64.898 62.9203L79.1 71.8703L79.9 72.3703L80.7 71.8703L94.902 62.8233L95.3 62.5703V62.2003V61.5703L94.859 61.8503L79.9 71.3703Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M65.9 99C64.9 99 64.2 99.8 64.2 100.7C64.2 101.7 65 102.4 65.9 102.4H101.9C102.9 102.4 103.6 101.6 103.6 100.7C103.6 99.7 102.8 99 101.9 99H65.9Z",
  fill: "#EAEAEA"
}), /*#__PURE__*/React.createElement("path", {
  d: "M65.6 106.4C64.6 106.4 63.9 107.2 63.9 108.1C63.9 109.1 64.7 109.8 65.6 109.8H101.6C102.6 109.8 103.3 109 103.3 108.1C103.3 107.1 102.5 106.4 101.6 106.4H65.6Z",
  fill: "#EAEAEA"
}), /*#__PURE__*/React.createElement("path", {
  d: "M100.1 71.0002H88.4C86.7 71.0002 85.2 69.6002 85.2 67.8002V57.4002C85.2 55.7002 86.6 54.2002 88.4 54.2002H100.1C101.8 54.2002 103.3 55.6002 103.3 57.4002V67.8002C103.3 69.6002 101.9 71.0002 100.1 71.0002Z",
  fill: "#EA4403"
}), /*#__PURE__*/React.createElement("path", {
  d: "M89.575 62.6921V62.6621C89.575 59.6001 91.442 57.1221 94.259 57.1221C97.06 57.1221 98.911 59.5701 98.911 62.6321V62.6621C98.911 65.7231 97.044 68.2021 94.227 68.2021C91.412 68.2021 89.575 65.7531 89.575 62.6921ZM96.968 62.6921V62.6621C96.968 60.5501 95.881 58.8201 94.228 58.8201C92.576 58.8201 91.519 60.5041 91.519 62.6321V62.6621C91.519 64.7741 92.59 66.5031 94.259 66.5031C95.927 66.5021 96.968 64.7891 96.968 62.6921Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M66.751 42.3958L67.333 43.7388H66.17L66.751 42.3958ZM66.496 41.5938L64.913 45.2178H65.531L65.94 44.2688H67.563L67.977 45.2178H68.6L67.018 41.5938H66.496Z",
  fill: "#260046"
}), /*#__PURE__*/React.createElement("path", {
  d: "M70.97 45.218H70.408V44.953C70.24 45.167 69.959 45.269 69.703 45.269C69.101 45.269 68.713 44.85 68.713 44.192V42.666H69.275V44.1C69.275 44.503 69.474 44.758 69.826 44.758C70.087 44.758 70.301 44.595 70.408 44.355V42.665H70.97V45.218Z",
  fill: "#260046"
}), /*#__PURE__*/React.createElement("path", {
  d: "M75.684 42.6656H76.246V43.0076C76.343 42.8136 76.603 42.6396 76.889 42.6396C76.996 42.6396 77.088 42.6546 77.149 42.6706L77.067 43.2166C77.016 43.1966 76.934 43.1856 76.847 43.1856C76.623 43.1856 76.357 43.3136 76.245 43.5786V45.2176H75.683V42.6656H75.684Z",
  fill: "#260046"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.444 45.2692C77.688 45.2692 77.173 44.6622 77.173 43.9422C77.173 43.2222 77.688 42.6152 78.444 42.6152C78.745 42.6152 79.011 42.7172 79.189 42.9012V42.6662H79.75V45.2182H79.189V44.9782C79.011 45.1672 78.745 45.2692 78.444 45.2692ZM78.51 44.7582C78.837 44.7582 79.056 44.6052 79.189 44.4012V43.4772C79.056 43.2782 78.837 43.1252 78.51 43.1252C78.061 43.1252 77.749 43.4932 77.749 43.9422C77.75 44.3912 78.061 44.7582 78.51 44.7582Z",
  fill: "#260046"
}), /*#__PURE__*/React.createElement("path", {
  d: "M80.259 41.6994L80.82 41.1514V45.2184H80.259V41.6994Z",
  fill: "#260046"
}), /*#__PURE__*/React.createElement("path", {
  d: "M81.609 42.2832C81.405 42.2832 81.236 42.1152 81.236 41.9052C81.236 41.7012 81.404 41.5322 81.609 41.5322C81.818 41.5322 81.987 41.7002 81.987 41.9052C81.986 42.1142 81.818 42.2832 81.609 42.2832ZM81.328 42.6652H81.89V45.2172H81.328V42.6652Z",
  fill: "#260046"
}), /*#__PURE__*/React.createElement("path", {
  d: "M83.573 45.2692C82.817 45.2692 82.302 44.6622 82.302 43.9422C82.302 43.2222 82.818 42.6152 83.573 42.6152C83.874 42.6152 84.14 42.7172 84.318 42.9012V42.6662H84.88V45.2182H84.318V44.9782C84.14 45.1672 83.874 45.2692 83.573 45.2692ZM83.639 44.7582C83.966 44.7582 84.185 44.6052 84.318 44.4012V43.4772C84.185 43.2782 83.966 43.1252 83.639 43.1252C83.19 43.1252 82.878 43.4932 82.878 43.9422C82.879 44.3912 83.19 44.7582 83.639 44.7582Z",
  fill: "#260046"
}), /*#__PURE__*/React.createElement("path", {
  d: "M85.388 42.6653H85.95V42.9363C86.123 42.7223 86.399 42.6143 86.7 42.6143C87.313 42.6143 87.701 43.0333 87.701 43.6913V45.2173H87.14V43.7823C87.14 43.3793 86.936 43.1243 86.578 43.1243C86.277 43.1243 86.057 43.2923 85.95 43.5273V45.2173H85.388V42.6653Z",
  fill: "#260046"
}), /*#__PURE__*/React.createElement("path", {
  d: "M88.7 44.2532C88.889 44.5442 89.19 44.7182 89.542 44.7182C89.884 44.7182 90.129 44.5392 90.129 44.2692C90.129 44.0142 89.961 43.8452 89.613 43.7182L89.215 43.5752C88.643 43.3662 88.362 43.0492 88.362 42.5542C88.362 41.9212 88.862 41.5332 89.536 41.5332C89.985 41.5332 90.368 41.7122 90.633 42.0282L90.219 42.4312C90.04 42.2172 89.816 42.0942 89.535 42.0942C89.229 42.0942 88.963 42.2522 88.963 42.5132C88.963 42.7782 89.136 42.8962 89.514 43.0342L89.882 43.1722C90.413 43.3712 90.735 43.6932 90.735 44.2342C90.73 44.8672 90.235 45.2812 89.525 45.2812C88.938 45.2812 88.448 45.0162 88.228 44.6272L88.7 44.2532Z",
  fill: "#260046"
}), /*#__PURE__*/React.createElement("path", {
  d: "M93.346 45.218H92.784V44.953C92.616 45.167 92.335 45.269 92.08 45.269C91.478 45.269 91.09 44.85 91.09 44.192V42.666H91.651V44.1C91.651 44.503 91.85 44.758 92.202 44.758C92.462 44.758 92.677 44.595 92.784 44.355V42.665H93.346V45.218V45.218Z",
  fill: "#260046"
}), /*#__PURE__*/React.createElement("path", {
  d: "M93.819 42.6653H94.381V42.9003C94.56 42.7163 94.825 42.6143 95.126 42.6143C95.887 42.6143 96.402 43.2213 96.402 43.9413C96.402 44.6613 95.886 45.2683 95.126 45.2683C94.825 45.2683 94.559 45.1663 94.381 44.9773V46.3403H93.819V42.6653ZM95.065 44.7583C95.516 44.7583 95.829 44.3873 95.826 43.9353C95.823 43.4233 95.346 43.0303 94.848 43.1493C94.634 43.2003 94.483 43.3253 94.382 43.4773V44.4013C94.513 44.6053 94.733 44.7583 95.065 44.7583Z",
  fill: "#260046"
}), /*#__PURE__*/React.createElement("path", {
  d: "M99.602 42.6656H100.164V43.0076C100.261 42.8136 100.521 42.6396 100.807 42.6396C100.914 42.6396 101.006 42.6546 101.068 42.6706L100.986 43.2166C100.935 43.1966 100.853 43.1856 100.767 43.1856C100.543 43.1856 100.277 43.3136 100.165 43.5786V45.2176H99.603V42.6656H99.602Z",
  fill: "#260046"
}), /*#__PURE__*/React.createElement("path", {
  d: "M72.512 43.7023L72.252 43.6253C72.002 43.5543 71.946 43.4463 71.946 43.3243C71.946 43.1713 72.119 43.0843 72.288 43.0843C72.497 43.0843 72.661 43.1863 72.773 43.3443L73.127 42.9983C72.945 42.7493 72.658 42.6143 72.298 42.6143C71.788 42.6143 71.389 42.8903 71.384 43.3443C71.379 43.7223 71.609 44.0033 72.053 44.1253L72.278 44.1863C72.584 44.2783 72.671 44.3653 72.671 44.5133C72.671 44.6923 72.503 44.7843 72.303 44.7843C72.043 44.7843 71.793 44.6563 71.691 44.4323L71.317 44.7973C71.513 45.1133 71.88 45.2693 72.304 45.2693C72.83 45.2693 73.228 44.9683 73.228 44.4783C73.227 44.0593 72.962 43.8353 72.512 43.7023Z",
  fill: "#260046"
}), /*#__PURE__*/React.createElement("path", {
  d: "M75.216 44.7002C75.106 44.7462 75.012 44.7642 74.853 44.7642C74.613 44.7642 74.455 44.6462 74.455 44.3302V43.1662H75.216V42.6662H74.455V41.6992H73.894V42.6662H73.394V43.1662H73.894V44.4222C73.894 44.9992 74.287 45.2692 74.782 45.2692C74.947 45.2692 75.098 45.2402 75.216 45.2052V44.7002Z",
  fill: "#260046"
}), /*#__PURE__*/React.createElement("path", {
  d: "M98.659 44.4543C98.519 44.6343 98.297 44.7583 97.986 44.7583C97.562 44.7583 97.225 44.4823 97.2 44.0643H99.206C99.211 43.9823 99.211 43.9363 99.211 43.8803C99.211 43.0583 98.649 42.6143 97.981 42.6143C97.196 42.6143 96.636 43.2043 96.649 43.9673C96.662 44.7443 97.338 45.3223 98.114 45.2643C98.543 45.2323 98.873 45.0453 99.088 44.7593L98.659 44.4543ZM97.96 43.0893C98.287 43.0893 98.583 43.2883 98.644 43.6563H97.225C97.302 43.2783 97.634 43.0893 97.96 43.0893Z",
  fill: "#260046"
}), /*#__PURE__*/React.createElement("path", {
  d: "M85.482 39.7491C85.365 39.7591 85.354 39.9261 85.468 39.9521L88.022 40.5411C88.222 40.0631 88.227 39.6411 87.885 39.5381L85.482 39.7491Z",
  fill: "url(#paint0_linear_411_2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M90.133 39.3423C90.229 39.3333 90.283 39.4513 90.214 39.5193L87.469 42.1973C87.387 42.2773 87.255 42.1843 87.304 42.0803L88.021 40.5423C88.221 40.0643 88.226 39.6433 87.884 39.5393L90.133 39.3423Z",
  fill: "url(#paint1_linear_411_2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50 135.9C50.4 135.7 50.7 135.5 51.1 135.2C51.3 135 51.6 134.9 51.8 134.7C66.3 125 66.3 109.8 59.2 95.0996C57.8 92.3996 56.7 89.7996 55.9 87.4996V67.2996C56.7 65.9996 57.6 64.8996 58.4 63.6996C60.3 61.1996 62.4 58.7996 63.3 55.7996C64.3 52.7996 63.9 49.1996 61.5 47.0996C60.9 46.5996 60.2 46.1996 59.5 46.2996C58.7 46.3996 58.1 47.0996 57.5 47.6996C53.8 52.3996 50 56.9996 46.2 61.4996C45 62.8996 43.8 64.3996 42.9 66.0996C42.1 67.5996 41.7 69.1996 41.2 70.8996C39.5 77.6996 38.6 84.5996 36.9 91.3996C35.5 97.0996 34.2 103.5 29.5 107.3C24.5 111.3 18.7 114.5 12.9 117.3C11.922 117.76 10.926 118.184 9.936 118.621C15.617 128.905 23.497 137.797 32.94 144.68C33.909 144.124 34.893 143.592 35.899 143.1C40.6 140.8 45.5 138.7 50 135.9Z",
  fill: "#F9BC84"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M54.7 69.8998C54.7 69.8998 51.3 74.0998 55.9 87.4998V67.2998C55.9 67.3998 55.8 67.3998 55.8 67.4998C55.4 68.0998 54.6 69.1998 54.7 69.8998Z",
  fill: "#B18B66"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_411_2",
  x1: 86.2965,
  y1: 40.6632,
  x2: 87.5274,
  y2: 39.1962,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.1155,
  stopColor: "#EA4403"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2632,
  stopColor: "#EA4A03"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4566,
  stopColor: "#EC5A03"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.65,
  stopColor: "#EE7203"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7747,
  stopColor: "#F18402"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F8AE00"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_411_2",
  x1: 87.4209,
  y1: 40.666,
  x2: 90.1186,
  y2: 40.902,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.1155,
  stopColor: "#EA4403"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2356,
  stopColor: "#EA4A03"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3928,
  stopColor: "#EC5A03"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.55,
  stopColor: "#EE7203"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6535,
  stopColor: "#F18402"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8604,
  stopColor: "#F9B301"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9959,
  stopColor: "#FFD500"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD500"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_411_2"
}, /*#__PURE__*/React.createElement("rect", {
  width: 160,
  height: 160,
  fill: "white"
})));

var SvgIllustrationNoNotifications = function SvgIllustrationNoNotifications(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIllustrationNoNotifications, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/illustration-no-notifications.42265b10.svg";
export { ForwardRef as ReactComponent };